<template>
  <div class="ml-3">
    <h2>Checkout with Moyasar</h2>
    <div id="moyasar-payment"></div>
  </div>
</template>

<script>
export default {
  name: "MoyasarPayment",
  props: {
    amount: {
      type: Number,
      required: true, // pass amount from parent in halalas (e.g. 10000 = 100 SAR)
    },
    callBack: {
      type: String,
    },
    description: {
      type: String,
      default: "Order Payment",
    },
  },
  mounted() {
    this.initMoyasar();
  },
  methods: {
    initMoyasar() {
      if (window.Moyasar && window.Moyasar.init) {
        window.Moyasar.init({
          element: "#moyasar-payment",
          amount: parseInt(this.amount) * 100, // 100.00 SAR
          currency: "SAR",
          description: "Booking Confirmation",
          publishable_api_key: process.env.VUE_APP_MOYASAR_TEST_KEY,
          callback_url: this.callBack,
          methods: ["creditcard", "mada"],
          // metadata: {
          //   invoice_id: generatedInvoiceId, // 👈 send this
          //   service_id: this.serviceId,
          // },
        });
      } else {
        console.warn("Moyasar not loaded yet, retrying...");
        setTimeout(this.initMoyasar, 500);
      }
    },
  },
};
</script>
